import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { CartService, CartItem } from '../../services/cart.service';
import { DownloadModalService } from '../../services/download-modal.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit, OnDestroy {
  items: CartItem[] = [];
  private sub?: Subscription;

  get itemCount(): number {
    return this.items.length;
  }

  get totalPrice(): number {
    return this.items.reduce((sum, item) => sum + (Number(item.price)), 0);
  }

  constructor(private cartService: CartService, private downloadModal: DownloadModalService, private location: Location) {}

  ngOnInit(): void {
    this.sub = this.cartService.items$.subscribe(items => {
      this.items = items;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  remove(id: number): void {
    this.cartService.remove(id);
  }

  downloadAll(): void {
    this.downloadModal.open(null, true);
  }

  goBack(): void {
    this.location.back();
  }
}


